import React from "react";
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
import { Card } from "../UI";

const tick = { fill: "var(--text-muted)", fontSize: 11 };

export const AnalyticsTrend = ({ series }) => {
  const data = (series || []).map((d) => ({ ...d, label: d.date.slice(5) }));
  return (
    <Card className="!p-5" data-testid="analytics-trend">
      <div className="flex items-baseline justify-between mb-3">
        <div className="font-display font-bold text-sm">Scans, claims & redemptions</div>
        <div className="text-[11px] text-slate-500">daily · {data.length} days</div>
      </div>
      <div style={{ width: "100%", height: 260 }}>
        <ResponsiveContainer width="100%" height={260}>
          <AreaChart data={data} margin={{ top: 4, right: 8, left: -18, bottom: 0 }}>
            <defs>
              <linearGradient id="gScans" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="var(--plum)" stopOpacity={0.35} /><stop offset="100%" stopColor="var(--plum)" stopOpacity={0} /></linearGradient>
              <linearGradient id="gClaims" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="var(--accent-primary)" stopOpacity={0.4} /><stop offset="100%" stopColor="var(--accent-primary)" stopOpacity={0} /></linearGradient>
              <linearGradient id="gRed" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="var(--success)" stopOpacity={0.4} /><stop offset="100%" stopColor="var(--success)" stopOpacity={0} /></linearGradient>
            </defs>
            <CartesianGrid stroke="rgb(var(--contrast-rgb) / 0.05)" vertical={false} />
            <XAxis dataKey="label" tick={tick} axisLine={false} tickLine={false} interval="preserveStartEnd" minTickGap={24} />
            <YAxis tick={tick} axisLine={false} tickLine={false} allowDecimals={false} />
            <Tooltip contentStyle={{ background: "var(--bg-elevated)", border: "1px solid rgb(var(--contrast-rgb) / 0.1)", borderRadius: 8, fontSize: 12 }} labelStyle={{ color: "var(--text-primary)" }} />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <Area type="monotone" dataKey="scans" name="Scans" stroke="var(--plum)" fill="url(#gScans)" strokeWidth={2} />
            <Area type="monotone" dataKey="claims" name="Claims" stroke="var(--accent-primary)" fill="url(#gClaims)" strokeWidth={2} />
            <Area type="monotone" dataKey="redemptions" name="Redemptions" stroke="var(--success)" fill="url(#gRed)" strokeWidth={2} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};
